import { render } from "./left-center.svg?vue&type=template&id=412fc4f4"
const script = {}

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__